import Button from "components/Button";
import Input from "components/Input";
import type { AlvysSecret } from "models/Alvys";
import { maskedSecret } from "./helpers";
import styles from "./style.module.scss";

interface IProps {
  id: string;
  label: string;
  secret: AlvysSecret;
  value: string;
  isReplacing: boolean;
  onReplace: (isReplacing: boolean) => void;
  onChange: (value: string) => void;
  error?: string;
}

export default function SecretField({
  id,
  label,
  secret,
  value,
  isReplacing,
  onReplace,
  onChange,
  error
}: Readonly<IProps>) {
  const fieldError = error ? { type: "required", message: error } : undefined;
  if (secret.configured && !isReplacing) {
    return (
      <div className={styles.inlineField}>
        <Input
          key="saved"
          id={id}
          label={label}
          value={maskedSecret(secret)}
          className="flex-1"
          readOnly
          error={fieldError}
        />
        <Button variant="outline" aria-label={`Replace ${label}`} onClick={() => onReplace(true)}>
          Replace
        </Button>
      </div>
    );
  }

  return (
    <div className={styles.inlineField}>
      <Input
        key="entry"
        id={id}
        label={label}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder="Paste from Alvys"
        className="flex-1"
        autoComplete="new-password"
        autoFocus={isReplacing}
        isPasswordIcon
        data-clarity-mask="True"
        data-hj-suppress=""
        error={fieldError}
      />
      {isReplacing && (
        <Button
          variant="text"
          aria-label={`Keep the current ${label}`}
          onClick={() => onReplace(false)}>
          Cancel
        </Button>
      )}
    </div>
  );
}
